module.exports = __webpack_public_path__ + "static/media/400401_02.013f482e.png";